import { render } from "./ProposalDraftActions.vue?vue&type=template&id=76c9587e&scoped=true&ts=true"
import script from "./ProposalDraftActions.vue?vue&type=script&lang=ts"
export * from "./ProposalDraftActions.vue?vue&type=script&lang=ts"

import "./ProposalDraftActions.vue?vue&type=style&index=0&id=76c9587e&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c9587e"]])

export default __exports__